import type { IntegrationSettingConstructor } from '../../entities/IntegrationSetting/IntegrationSetting'
import type { IntegrationSettingApiModel } from '../api-models/IntegrationSettingApiModel'

export const mapIntegrationSettingApiModel = (
  integrationSettingApiModel: IntegrationSettingApiModel
): IntegrationSettingConstructor => {
  return {
    id: integrationSettingApiModel.id,
    settingKey: integrationSettingApiModel.setting_key,
    settingValue: integrationSettingApiModel.setting_value,
  }
}
